CCL.categoryFacets = {
  autoload: [
    ['facetsToggle', $('body').length > 0]
  ],

  facetsToggle() {
    $('body').on('click keypress', '.filter-btn', (e) => {
      $(e.currentTarget).attr('aria-label', 'Filter button that contain options to see is expanded');
      $('body').find('.c-category-facets').show();
      $('body').find('.c-category-facets .btn-blue').focus();
    });
    // $('.filter-btn-wrap .btn-blue-link').click(() => {
    //   $('.c-category-facets').hide();
    // });
    // $('.filter-btn-wrap .btn-blue').click(() => {
    //   $('.c-category-facets').hide();
    // });
  }
};




// WEBPACK FOOTER //
// ./src/app/components/c-category-facets/category-facets.js